'use client'

import { m } from 'framer-motion'
import { Calendar, Sparkles } from 'lucide-react'

interface ArticleHeroProps {
  title: string
  publishedAt: Date | string
  author: string
}

function formatRuDateUTC(d: Date | string | undefined | null) {
  if (!d) return '—'
  const date = typeof d === 'string' ? new Date(d) : d
  try {
    return new Intl.DateTimeFormat('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(date)
  } catch {
    return date.toISOString().slice(0, 10)
  }
}

export default function ArticleHero({ title, publishedAt, author }: ArticleHeroProps) {
  return (
    <section className="hero-mobile-safe relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden px-4">
      <div className="home-container relative z-10 text-center">
        <m.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-8 inline-flex flex-wrap items-center justify-center gap-3 sm:mb-8 sm:gap-4"
        >
          <span className="home-meta flex items-center gap-2 rounded-full border border-blue-500/20 bg-blue-500/10 px-3 py-1.5 text-blue-300">
            <Sparkles size={12} />
            Insights
          </span>
          <span className="home-meta flex items-center gap-2 text-gray-400">
            <Calendar size={12} /> {formatRuDateUTC(publishedAt)}
          </span>
        </m.div>

        <m.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="home-title article-hero-title-mobile mx-auto mb-8 max-w-5xl text-balance sm:mb-12"
        >
          <span className="text-white drop-shadow-[0_0_30px_rgba(255,255,255,0.1)]">{title}</span>
        </m.h1>

        <m.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex justify-center"
        >
          <div className="home-meta text-gray-500">
            by <span className="border-b border-white/20 pb-0.5 text-white">{author}</span>
          </div>
        </m.div>
      </div>
    </section>
  )
}
